module.exports = __webpack_public_path__ + "img/icon_box_3_1.8a29adc9.png";